import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const SalesChartSummary = ({ dataset }) => {
  if (!dataset || !dataset.labels || !dataset.datasets) {
    return <p>No chart data available.</p>;
  }

  // Ensure all values in data arrays are numbers
  const cleanedData = {
    labels: dataset.labels,
    datasets: dataset.datasets.map((ds) => ({
      ...ds,
      data: ds.data.map((val) => Number(val)),
    })),
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
      },
    },
  };

  return (
    <div className="w-full">
      <Bar data={cleanedData} options={options} />
    </div>
  );
};

export default SalesChartSummary;
